/**
 * Esta directiva esta diorectemente realcionada con la vista de sample.schedule
 * se le aasocia a cada elemento de la lista el tooltip a mostrar
 * @returns
 */
function sampleListRenderDirective() {
	// I link the DOM element to the view model.
	function link($scope, element, attributes) {
		$scope.ctrl.setToolTip(element, $scope.sample);
	}
	// Return directive configuration.
	return ({
		link : link,
		restrict : "A"
	});
}

module.directive('sampleListRender', [ sampleListRenderDirective ]);